import React from 'react';
import { Select } from '@mantine/core';

const OPTIONS = [
  { value: '1', label: 'Titre 1' },
  { value: '2', label: 'Titre 2' },
  { value: '3', label: 'Titre 3' },
  { value: '4', label: 'Titre 4' },
];

export default function TitleLevelField({ value, onChange }) {
  return (
    <Select
      size="xs"
      label="Niveau de titre"
      data={OPTIONS}
      value={String(value ?? 1)}
      onChange={(next) => onChange(Number(next) || 1)}
      allowDeselect={false}
    />
  );
}
